import React from "react";
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ListActions,
  minValue,
  NumberInput,
  SimpleList,
  TextField,
} from "react-admin";
import { Box, useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import { MoneyField } from "server/components/Fields/MoneyField";
import SecuredComponent from "server/security/SecuredComponent";
import DetailsDialog from "./DetailsDialog";
import UpdatePriceDialog from "./UpdatePriceDialog";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const filters = [
  <NumberInput
    source="fromYear"
    label="От година"
    validate={minValue(2025)}
    alwaysOn
  />,
  <NumberInput
    source="toYear"
    label="До година"
    validate={minValue(2025)}
    alwaysOn
  />,
];

const ListHealthcareCourseDailyPrices = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Дневни такси курсове за здравни грижи"
      filters={filters}
      exporter={false}
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageHealthcareCourseDailyPrices)} />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Година", value: record?.year }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Дневна такса (EUR)",
                    value: <MoneyField source="price" />,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Последно редактиран",
                    value: (
                      <DateField
                        source="updatedOn"
                        locales="bg-BG"
                      />
                    ),
                  },
                ]}
              />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent permission={permissions.canPreviewHealthcareCourseDailyPrices}>
                  <DetailsDialog year={record?.year} />
                </SecuredComponent>

                <SecuredComponent permission={permissions.canManageHealthcareCourseDailyPrices}>
                  <UpdatePriceDialog year={record?.year} />
                </SecuredComponent>
              </div>
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={{
            "& .RaDatagrid-headerCell": {
              textAlign: "left",
            },
          }}
        >
          <TextField
            source="year"
            label="Година"
            sortable={false}
          />
          <MoneyField
            source="price"
            label="Дневна такса (EUR)"
            sortable={false}
          />
          <DateField
            source="updatedOn"
            label="Последно редактиран"
            locales="bg-BG"
            sortable={false}
          />
          <FunctionField
            render={rec => (
              <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                <SecuredComponent permission={permissions.canPreviewHealthcareCourseDailyPrices}>
                  <DetailsDialog year={rec?.year} />
                </SecuredComponent>

                <SecuredComponent permission={permissions.canManageHealthcareCourseDailyPrices}>
                  <UpdatePriceDialog year={rec?.year} />
                </SecuredComponent>
              </Box>
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListHealthcareCourseDailyPrices;
